// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  CheckRounded,
  ContentCopyRounded,
} from '@/constants/hardfin-standard-icons';
import { IconButton, Tooltip } from '@mui/material';
import { MouseEvent, useState } from 'react';

interface Props {
  /**
   * The order number to copy to the clipboard (e.g. an FO or RO number).
   */
  orderNumber: string;
}

export function OrderNumberCopyButton(props: Props) {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = async (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();

    try {
      await navigator.clipboard.writeText(props.orderNumber);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 1500);
    } catch (error) {
      console.error('Failed to copy order number:', error);
    }
  };

  return (
    <Tooltip title={isCopied ? 'Copied!' : 'Copy order number'} arrow>
      <IconButton
        size="small"
        onClick={handleCopy}
        aria-label={isCopied ? 'Copied' : 'Copy order number'}
        sx={{
          color: isCopied ? 'success.main' : 'action',
          transition: 'color 0.2s ease-in-out',
        }}
      >
        {isCopied ? (
          <CheckRounded fontSize="small" />
        ) : (
          <ContentCopyRounded fontSize="small" />
        )}
      </IconButton>
    </Tooltip>
  );
}
